
const ReserveResponse = {
	// "version": "1.0.0.0",
	// "statusCode": 200,
	// "message": "OK",
	// "responseException": null,
  // "result": {}
	 "paymentDeadline": "string",
  "vatNumber": "string",
  "provider": 0,
  "providerName": "string",
  "totalPrice": 0,
  "remarks": [
    "string"
  ],
  "cancelationPolicyChange": "string",
  "gdsRefrenceID": "string"

};
 

  export default ReserveResponse;
  